import {
    validateCallOutcomeId,
    validateIwsCallNotes,
    validateWorkConfidenceId
} from './validationFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    newErrors = validateCallOutcomeId(newEntry.callOutcomeId, newErrors);
    newErrors = validateWorkConfidenceId(newEntry.workConfidenceId, newErrors);
    newErrors = validateIwsCallNotes(newEntry.note, newErrors);

    return newErrors;
};
